import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import useLanguage from '../hooks/useLanguage';
import LanguageSelector from './LanguageSelector';

const { FiSun, FiMoon, FiMonitor, FiBookOpen } = FiIcons;

const Header = ({ theme, setTheme }) => {
  const { t } = useLanguage();
  
  const themeOptions = [
    { value: 'light', icon: FiSun, label: 'Claro' },
    { value: 'dark', icon: FiMoon, label: 'Oscuro' },
    { value: 'auto', icon: FiMonitor, label: 'Auto' }
  ];

  return (
    <motion.header 
      className="bg-white/80 dark:bg-gray-900/80 backdrop-blur-lg border-b border-gray-200 dark:border-gray-700 sticky top-0 z-40 min-h-[64px]"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo y Título - Versión móvil optimizada */}
          <motion.div 
            className="flex items-center space-x-2 sm:space-x-3 flex-1 min-w-0"
            whileHover={{ scale: 1.02 }}
            transition={{ type: "spring", stiffness: 400 }}
          >
            <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg sm:rounded-xl flex items-center justify-center shadow-lg flex-shrink-0">
              <SafeIcon icon={FiBookOpen} className="text-white text-lg sm:text-xl" />
            </div>
            <div className="min-w-0 flex-1">
              <h1 className="text-sm sm:text-xl font-bold text-gray-900 dark:text-white truncate">
                {t('title')}
              </h1>
              {/* Eslogan optimizado para móvil - solo visible en desktop */}
              <p className="hidden sm:block text-xs text-gray-600 dark:text-gray-400 truncate">
                {t('subtitle')}
              </p>
              {/* Versión móvil del eslogan - más corta */}
              <p className="sm:hidden text-xs text-gray-600 dark:text-gray-400 truncate">
                {t('subtitle').substring(0, 40)}...
              </p>
            </div>
          </motion.div>
          
          {/* Controles - Versión móvil optimizada */}
          <div className="flex items-center space-x-1 sm:space-x-2 flex-shrink-0">
            {/* Language Selector - más pequeño en móvil */}
            <div className="scale-90 sm:scale-100">
              <LanguageSelector />
            </div>
            
            {/* Theme Selector - más compacto en móvil */}
            {themeOptions.map((option) => (
              <motion.button
                key={option.value}
                onClick={() => setTheme(option.value)}
                className={`p-1.5 sm:p-2 rounded-lg transition-all duration-200 ${
                  theme === option.value
                    ? 'bg-blue-100 dark:bg-blue-900 text-blue-600 dark:text-blue-400'
                    : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800'
                }`}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                title={option.label}
              >
                <SafeIcon icon={option.icon} className="text-base sm:text-lg" />
              </motion.button>
            ))}
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;